// Reducers
import { documentPreviewReducer } from './documentPreview/reducer';
import { mailboxReducer } from './mailbox/reducer';
import { userReducer } from './user/reducer';
import { profileReducer } from './profile/reducer';
import { sidebarReducer } from './sidebar/reducer';
import { menubarReducer } from './menubar/reducer';
import { appReadoutsReducer } from './appreadouts/reducer';
import { senderReducer } from './sender/reducer';

export const reducer = {
    documentPreview: documentPreviewReducer,
    user: userReducer,
    mailbox: mailboxReducer,
    profile: profileReducer,
    sidebar: sidebarReducer,
    appReadouts: appReadoutsReducer,
    menubar: menubarReducer,
    sender: senderReducer,
};
